
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[seoUrl]",
      function () {
        return require("private-next-pages/blogs/[seoUrl].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/[seoUrl]"])
      });
    }
  